import React from 'react';
import ReactDOM from 'react-dom';
import '@fontsource-variable/inter';
import './index.css';
import App from './App';
import OneSignal from 'react-onesignal';

// Initialize OneSignal (prompt will be shown after login in App.tsx)
// Auto-prompting is disabled - we manually show the prompt after login
OneSignal.init({
  appId: "c866df36-d3e8-44b5-be0d-0ec98713309a",
  allowLocalhostAsSecureOrigin: true,
  notifyButton: {
    enable: false,  // Disable the floating bell button
  },
} as any).then(() => {
  console.log('OneSignal initialized');
});

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);